import { Component, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { NavController, NavParams, Slides, LoadingController, Platform } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Localization } from '../../app/app.localization';
import { ModalController } from 'ionic-angular';
import { OrderModalPage } from "../../pages/order-modal/order-modal";
import { Broadcaster } from '../../app/broadcaster';
import { subscribeOn } from 'rxjs/operator/subscribeOn';
import { OkageStorageProvider } from '../../providers/okage-storage/okage-storage'

/**
 * Generated class for the OrderComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'order',
  templateUrl: 'order.html'
})
export class OrderComponent {

  @ViewChild("wrapper") wrapper: any;
  @Input() menu_id: number;
  @Input() orderList: any;
  @Output() public hideOrder = new EventEmitter<any>();
  @Output() public goCart = new EventEmitter<any>();

  //menus: Array<Array<{ id: number, title: string, desc: string, thumb: string, price: number, like: number; liked: boolean, sub: any, is_rock: any, is_soldout_rock: any, is_wait_arrival_rock: any }>>;
  menus: Array<Array<{ id: number, title: string, desc: string, thumb: string, price: number, notax_price: number, like: number; liked: boolean, sub: any, is_rock: any, is_soldout_rock: any, is_wait_arrival_rock: any, allergy: any, menu_limit_in_order: any}>>;
  subMenu: any;
  currentItem: { id: number, title: string, desc: string, thumb: string, price: number, aIndex: number, iIndex: number, like: number, liked: boolean, subParts: any, flowQtt: any, flowQttItem: any, isSelect: Array<boolean>, allergy: Array<boolean>, flowSelectedSequence:any, menu_limit_in_order: any};
  currentPrice: number;
  quantity: any;
  quantityOption = [];
  quantitySubOption = [];
  heightPop: any;
  requiredSelectCount = 0;
  nextButtonActive: boolean = false;
  foodDetailState = "";
  foodDetailSubsState = "";
  //orderList = [];
  orderListNum: number = 0;
  chargeId: any;

  constructor(
    private storage: Storage,
    private _loc: Localization,
    private platform: Platform,
    private broadcaster: Broadcaster,
    private _okageStorage: OkageStorageProvider,
    public modalCtrl: ModalController,
  ) {
    this.currentItem = {
        id: 0,
        title: '',
        desc: '',
        thumb: '',
        price: 0,
        aIndex: -1,
        iIndex: -1,
        like: 0,
        liked: false,
        subParts: null,
        flowQtt: null,
        flowQttItem: null,
        flowSelectedSequence: [],
        isSelect: [],
        allergy: [],
        menu_limit_in_order: 0,
    };
  }

  ngOnInit(){
    this.init();
    this.foodDetailSubsState = "food-detail-up";
    this.foodDetailState = "food-detail-up";
  }

  async init(){
    // 初期数量
    this.quantity = 1;
    // メニューをload
    this.menus = await this.storage.get('foods.menu');
    // サブメニューをload
    this.subMenu = JSON.parse(this._okageStorage.getItem('foods.submenu'));
    // 詳細画面の数量の選択肢を作成
    this.quantityOption = [];
    for (let i = 1; i < 100; i++) {
        this.quantityOption.push({
            count: i
        });
    }
    // サブメニューの数量選択肢を作成
    this.quantitySubOption = [];
    for (let i = 0; i < 100; i++) {
        this.quantitySubOption.push({
            count: i
        });
    }

    // menusにサブをセットしておく
    for (var i = 0; i < this.menus.length; i++) {
        for (var j = 0; j < this.menus[i].length; j++) {
            if (typeof this.subMenu[this.menus[i][j].id] !== 'undefined') {
                this.menus[i][j].sub = this.subMenu[this.menus[i][j].id];
            }
        }
    }

    let {aIndex, iIndex, menu} = this.getIndexes(this.menu_id);
    this.currentItem = {
      id: menu.id,
      title: menu.title,
      desc: '',
      thumb: menu.thumb,
      price: menu.price,
      aIndex: aIndex,
      iIndex: iIndex,
      like: 0,
      liked: false,
      subParts: null,
      flowQtt: null,
      flowQttItem: null,
      flowSelectedSequence: [],
      isSelect: [],
      allergy: this.menus[aIndex][iIndex].allergy,
      menu_limit_in_order: (this.menus[aIndex][iIndex].menu_limit_in_order > 0) ? this.menus[aIndex][iIndex].menu_limit_in_order : 99
    };

    if (this.menus[aIndex][iIndex].sub && this.menus[aIndex][iIndex].sub.length > 0){
      // masterにsubがあればsetsub
      this.setSubs(this.menu_id,  aIndex, iIndex);

    }
    // 高さ計算
    this.platform.ready().then(() => {
        this.heightPop = String(this.platform.height() - 48) + 'px';
    });

    //this.orderList = JSON.parse(localStorage.getItem('orderList')) ? JSON.parse(localStorage.getItem('orderList')) : [];
    this.orderListNum = this.orderList.length;
    this.updateCurrentPrice();
    this.setMenuLimitQuantity();
  }

  /**
   * サブ情報のセット
   */
  setSubs(menu_id, aIndex, iIndex){
    let csubs = this.menus[aIndex][iIndex].sub.length;
    let cpIndex = 0;
    this.currentItem.subParts = [];
    this.currentItem.flowQtt = [];
    this.currentItem.flowQttItem = [];
    this.currentItem.subParts[cpIndex] = [];
    this.currentItem.flowQtt[menu_id] = [];
    this.currentItem.flowQttItem[menu_id] = [];
    for (var i = 0; i < csubs; i++) {
      this.currentItem.flowQtt[menu_id][i] = 0;
      this.currentItem.flowQttItem[menu_id][i] = this.menus[aIndex][iIndex].sub[i];
      this.menus[aIndex][iIndex].sub[i].index = i;
      if ('group_name' in this.menus[aIndex][iIndex].sub[i]) {
        if (i > 0) {
          if ('group_name' in this.menus[aIndex][iIndex].sub[i - 1]) {
            if (this.menus[aIndex][iIndex].sub[i].group_name != this.menus[aIndex][iIndex].sub[i - 1].group_name) {
              this.currentItem.subParts[++cpIndex] = [];
            }
          } else {
            this.currentItem.subParts[++cpIndex] = [];
          }
        }
        this.currentItem.subParts[cpIndex].push(this.menus[aIndex][iIndex].sub[i]);
      } else {
        if (i > 0) {
          this.currentItem.subParts[++cpIndex] = [];
          this.currentItem.subParts[cpIndex].push(this.menus[aIndex][iIndex].sub[i]);
        } else {
          this.currentItem.subParts[cpIndex].push(this.menus[aIndex][iIndex].sub[i]);
        }
      }
    }
    if (this.currentItem.subParts && this.currentItem.subParts.length > 0) {
      var optionsRowCount = 0;
      for (let i = 0; i < this.currentItem.subParts.length; i++) {
        for (let t = 0; t < this.currentItem.subParts[i].length; t++) {
          let obj = this.currentItem.subParts[i][t];
          this.currentItem.subParts[i][t].sort_order_in_group = this.searchFromSubMst(obj.group_id, obj.id);
        }
        // 展開メニューでサブメニューが必須項目ではない場合、次へボタンは活性化させる
        if (this.currentItem.subParts[i][0].required) {
          // optionsRowCount++;
        }
        this.currentItem.subParts[i].sort((a, b) => {
          if (parseInt(a.sort_order, 0) > parseInt(b.sort_order, 0)) return 1;
          if (parseInt(a.sort_order, 0) < parseInt(b.sort_order, 0)) return -1;
          if (parseInt(a.sort_order_in_group, 0) > parseInt(b.sort_order_in_group, 0)) return 1;
          if (parseInt(a.sort_order_in_group, 0) < parseInt(b.sort_order_in_group, 0)) return -1;
        });
      }
    }
  }

  /**
   * 並び順返却
   * @param menu_id
   * @param sub_menu_id
   */
  searchFromSubMst(menu_id, sub_menu_id) {
    // if (this.subSortMap.length < 1) {
    //   this.subSortMap = [];
    //   if (this.subMst && this.subMst.length > 0) {
    //     for (let i = 0; i < this.subMst.length; i++) {
    //       this.subSortMap[this.subMst[i].menu_id + "_" + this.subMst[i].sub_menu_id] = this.subMst[i].sort_order;
    //     }
    //   }
    // }
    // if (this.subSortMap[menu_id + "_" + sub_menu_id]) {
    //   return this.subSortMap[menu_id + "_" + sub_menu_id];
    // }
    return -1;
  }

  /**
   * nextButtonActiveの状態をアップデート
   *
   * 単品の際はこれがtrueじゃなくても決定はactiveだから、
   * subの場合のみ気にすればよい
   *
   */
  updateNextButtonActive() {
    // 一つでもだめならfalseなので、とりあえずtrueにして、falseあったらかえて即返し
    this.nextButtonActive = true;

    // もしsubなかったらtrue
    if (!this.currentItem.subParts || this.currentItem.subParts.length < 1) {
      return;
    }

    /**
     * sub groupを一つずつチェックしてvalidate
     */
    for (let subs of this.currentItem.subParts) {
      /**
       * ちなみにsubs[0]とかやってるのは、subのひとつひとつに、親のrequiredをいれてるから
       * いれてるのはapp.components.ts:469あたり
       */
      let parent_menu_id = this.currentItem.id;
      let flowQtt = this.currentItem.flowQtt[parent_menu_id];
      var subtotal = 0; // subの合計個数
      for (let subitem of subs) {
        subtotal += flowQtt[subitem.index];
      }
      if (subs[0].required) {
        // 必須のグループ - 全部0ならfalse
        console.log("CHECK FOR REQUIRED GROUP");
        if (subtotal < 1) {
          console.warn("   - [FAIL] NOT SELECTED");
          this.nextButtonActive = false;
          return;
        }
        console.log("   - PATH");
      }
      else if (subs[0].parent_min > 0) {
        // minが設定されている場合
        console.log("CHECK FOR OPTION MIN");
        if (subtotal < subs[0].parent_min) {
          console.warn("  - [FAIL] NOT ENOUGHT MIN:" + subs[0].parent_min + " CURRENT:" + subtotal);
          this.nextButtonActive = false;
          return;
        }
        console.log("   - PATH MIN:" + subs[0].parent_min + " CURRENT:" + subtotal);
      }
      else if (subs[0].parent_max > 0) {
        console.log("CHECK FOR OPTION MAX");
        if (subtotal > subs[0].parent_max) {
          console.warn("  - [FAIL] OVER MAX:" + subs[0].parent_max + " CURRENT:" + subtotal);
          this.nextButtonActive = false;
          return;
        }
        console.log("   - PATH");
      }
    }
    console.log("PASS ALL");
  }


  /**
   * 現在価格の更新
   * @param subPrice
   */
  updateCurrentPrice(subPrice: number = 0) {
    var price: number = (this.currentItem.price * this.quantity);
    if (this.currentItem.flowQtt) {
      var i: number = this.currentItem.flowQtt[this.currentItem["id"]].length;
      for (var j = 0; j < i; j++) {
        price += this.currentItem.flowQtt[this.currentItem["id"]][j] * this.currentItem.flowQttItem[this.currentItem["id"]][j].price * this.quantity;
      }
    }
    this.currentPrice = price;
  }

  clicksubDecrease(menuid, subindex, selectedId) {
    let targetSubmenu = null;
    for (var i = 0; i < this.currentItem.subParts.length; i++) {
      if (this.currentItem.subParts[i][0].group_id == subindex) {
        var subs = this.currentItem.subParts[i];
        for (let s of subs) {
          if (s.index == selectedId) {
            targetSubmenu = s;
            break;
          }
        }
      }
    }
    if (targetSubmenu && this.currentItem.flowSelectedSequence[targetSubmenu.group_id]){
      let seq = this.currentItem.flowSelectedSequence[targetSubmenu.group_id];
      var index = -1;
      for (let r=seq.length-1; r>=0; r--){
        if (seq[r].id == targetSubmenu.id){
          index = r;
          break;
        }
      }
      if (index >= 0){
        var nseq = seq.slice(0, index).concat(seq.slice(index+1, seq.length));
        this.currentItem.flowSelectedSequence[targetSubmenu.group_id] = nseq;
      }
    }
    this.currentItem.flowQtt[menuid][selectedId]--;
    this.updateNextButtonActive();

    var i: number = this.currentItem.flowQtt[menuid].length;
    var subPrice: number = 0;
    for (var j = 0; j < i; j++) {
      subPrice += this.currentItem.flowQtt[menuid][j] * this.currentItem.flowQttItem[menuid][j].price;
    }
    this.updateCurrentPrice(subPrice);

  }

  /**
   * サブメニューをクリック
   *
   * @param menuid
   * @param subindex
   * @param selectedId
   * @param fromSub
   */
  clicksubIncrease(menuid, subindex, selectedId, fromSub = false) {
    var optionsRowCount = 0;
    var isSelect = false;

    if (fromSub) {
      let subs = [];
      let targetSubmenu = null;
      for (var i = 0; i < this.currentItem.subParts.length; i++) {
        if (this.currentItem.subParts[i][0].group_id == subindex) {
          subs = this.currentItem.subParts[i];
          for (let s of subs){
            if (s.index == selectedId){
              targetSubmenu = s;
              break;
            }
          }
        }
        if (this.currentItem.subParts[i][0].required) {
          optionsRowCount++;
        }
      }

      var subtotal = 0;   // subの数量合計を保持
      for (var i = 0; i < subs.length; i++) {
        if (this.currentItem.flowQtt[menuid][subs[i].index] == 1) {
          isSelect = true;
        }
        subtotal += this.currentItem.flowQtt[menuid][subs[i].index];
      }
      // reset quantity number of required group menu
      if (subs[0].required) {
        for (var i = 0; i < subs.length; i++) {
          this.currentItem.flowQtt[menuid][subs[i].index] = 0;
        }
        this.currentItem.flowQtt[menuid][selectedId] = 1;
        if (!isSelect) {
          this.requiredSelectCount++;
        }
        // add sequence
        if (targetSubmenu){
          this.currentItem.flowSelectedSequence[targetSubmenu.group_id] = [];
          this.currentItem.flowSelectedSequence[targetSubmenu.group_id].push(targetSubmenu);
        }

      }
      else if (subs[0].parent_min > 0 || subs[0].parent_max > 0) {
        // min と maxがある場合
        if (subs[0].parent_max > subtotal) {
          // maxがsubtotal以上だったらincrement
          this.currentItem.flowQtt[menuid][selectedId]++;
          // add sequence
          if (targetSubmenu){
            if (!this.currentItem.flowSelectedSequence[targetSubmenu.group_id]){
              this.currentItem.flowSelectedSequence[targetSubmenu.group_id] = [];
            }
            this.currentItem.flowSelectedSequence[targetSubmenu.group_id].push(targetSubmenu);
          }
        }
      }
      else {
        this.currentItem.flowQtt[menuid][selectedId] = parseInt(this.currentItem.flowQtt[menuid][selectedId]);
      }
    } else {
      this.subMenu[menuid][subindex].quantity++;
    }

    console.log("sequence!");
    console.log(this.currentItem.flowSelectedSequence);

    // 必須のサブメニューを選択すると、次へボタンが活性化する
    // if (this.requiredSelectCount >= optionsRowCount) {
    //   this.nextButtonActive = true;
    // }
    this.updateNextButtonActive();

    var i: number = this.currentItem.flowQtt[menuid].length;
    var subPrice: number = 0;
    for (var j = 0; j < i; j++) {
      subPrice += this.currentItem.flowQtt[menuid][j] * this.currentItem.flowQttItem[menuid][j].price;
    }
    this.updateCurrentPrice(subPrice);
  }

  setMenuLimitQuantity() {
    this.quantityOption = [];
    let menuLimitQuantity = 99;
    this.storage.get('menu.list').then((m) => {
        var menuData = m.result.find(m => (m.menu_id == this.currentItem.id));
        var orderData = this.orderList.find(o => (o.menu_id == this.currentItem.id));
        if (menuData.menu_limit_in_order > 0) {
            menuLimitQuantity = menuData.menu_limit_in_order;
        }
        if (orderData) {
            menuLimitQuantity = menuLimitQuantity - orderData.quantity;
        }
        for (let i = 1; i <= menuLimitQuantity; i++) {
            this.quantityOption.push({
                count: i
            });
        }
    });
  }  

  /**
   * 注文を決定
   *
   * foods.selectedを更新する
   */
  async decideOrder(){
    let menuQuantityText = String(this.quantity);
    let menuQuantity = parseInt(menuQuantityText);
    // グループメニューの場合
    if (this.currentItem.flowQtt) {
        let sameOrder = false;
        // カートに同じ注文があるかチェック
        for (let i = 0; i < this.orderList.length; i++) {
            if (this.orderList[i].menu_id == this.currentItem.id) {
                sameOrder = true;
                for (let j = 0; j < this.orderList[i].sub.length; j++) {
                    // 同じサブメニュー
                    if (this.currentItem.flowQttItem[this.currentItem.id][j].id && this.orderList[i].sub[j].menu_id == this.currentItem.flowQttItem[this.currentItem.id][j].id) {
                        let currentQuantity = this.orderList[i].sub[j].quantity;
                        let ordersQuantity = this.currentItem.flowQtt[this.currentItem.id][j];
                        // トッピングは数量が一致する場合同じと判定
                        if ((this.currentItem.flowQttItem[this.currentItem.id][j].as_topping == "1") && ordersQuantity != currentQuantity) sameOrder = false;
                        // トッピング以外は選択した項目が一致する場合に同じと判定
                        if ((this.currentItem.flowQttItem[this.currentItem.id][j].as_topping != "1") && ordersQuantity > 0 && currentQuantity == 0) sameOrder = false;
                    }
                }
                // カートに同じ注文がある場合、数量のみ変更
                if (sameOrder) {
                    this.orderList[i].quantity = this.orderList[i].quantity + menuQuantity;
                    this.orderList[i].origin_quantity = this.orderList[i].origin_quantity + menuQuantity;
                    break;
                }
            }
        }
        // カートに同じ注文がない
        if (!sameOrder) {
            //親メニュー追加
            this.orderList.push(
                {
                    orderListNum: this.orderListNum++,
                    price: this.currentItem.price,
                    notax_price: this.menus[this.currentItem.aIndex][this.currentItem.iIndex].notax_price,
                    menu: {
                        menu_id: this.currentItem.id,
                    },
                    menu_id: this.currentItem.id,
                    title: this.menus[this.currentItem.aIndex][this.currentItem.iIndex].title,
                    origin_quantity: menuQuantity,
                    original_especial_price: this.currentItem.price,
                    quantity: menuQuantity,
                    remarks: "OkageGo",
                    sub: [],
                    menu_limit_in_order: this.currentItem.menu_limit_in_order,
                }
            );
            //サブメニュー追加
            for (let i = 0; i < this.currentItem.flowQttItem[this.currentItem.id].length; i++) {
                let subQuantity = this.currentItem.flowQtt[this.currentItem.id][i];
                this.orderList[this.orderList.length-1].sub.push(
                    {
                        orderListSubNum: i,
                        price: this.currentItem.flowQttItem[this.currentItem.id][i].price,
                        notax_price: this.currentItem.flowQttItem[this.currentItem.id][i].notax_price,
                        menu: {
                            menu_id: this.currentItem.flowQttItem[this.currentItem.id][i].id,
                        },
                        menu_id: this.currentItem.flowQttItem[this.currentItem.id][i].id,
                        title: this.currentItem.flowQttItem[this.currentItem.id][i].title,
                        origin_quantity: this.currentItem.flowQtt[this.currentItem.id][i],
                        original_especial_price: this.currentItem.flowQttItem[this.currentItem.id][i].price,
                        parent_menu_id: this.currentItem.flowQttItem[this.currentItem.id][i].parent,
                        quantity: subQuantity,
                        as_topping: this.currentItem.flowQttItem[this.currentItem.id][i].as_topping,
                        remarks: "OkageGo",
                    }
                );
            }
        }
    } else {　// 単品メニューの場合
        const findMenuIndex = this.orderList.findIndex((v) => v.menu_id === this.currentItem.id);
        // カートに同じ注文がない場合
        if (findMenuIndex < 0) {
            this.orderList.push(
                {
                    orderListNum: this.orderListNum++,
                    price: this.currentItem.price,
                    notax_price: this.menus[this.currentItem.aIndex][this.currentItem.iIndex].notax_price,
                    menu: {
                        menu_id: this.currentItem.id,
                    },
                    menu_id: this.currentItem.id,
                    title: this.menus[this.currentItem.aIndex][this.currentItem.iIndex].title,
                    origin_quantity: menuQuantity,
                    original_especial_price: this.currentItem.price,
                    quantity: menuQuantity,
                    remarks: "OkageGo",
                    sub: [],
                    menu_limit_in_order: this.currentItem.menu_limit_in_order,
                }
            );
        } else { // カートに同じ注文がある場合
            this.orderList[findMenuIndex].quantity = this.orderList[findMenuIndex].quantity + menuQuantity;
            this.orderList[findMenuIndex].origin_quantity = this.orderList[findMenuIndex].origin_quantity + menuQuantity;
        }
    } console.log("set this.orderList :"+this.orderList);

    this.chargeId = localStorage.getItem("chargeId");
    if (this.chargeId && localStorage.getItem("receiveMethod") === 'delivery') {
        for(let i = 0; i < this.orderList.length; i++) {
            if (this.orderList[i].menu_id === this.chargeId) {
                this.orderList.splice(i, 1);
            }
        }
        for (let a = 0; a < this.menus.length; a++) {
            for (let b = 0; b < this.menus[a].length; b++) {
                if (this.menus[a][b].id == this.chargeId) {
                    this.orderList.push({
                        orderListNum: this.orderListNum++,
                        price: this.menus[a][b].price,
                        notax_price: this.menus[a][b].notax_price,
                        menu: {
                            menu_id: this.menus[a][b].id,
                        },
                        menu_id: this.menus[a][b].id,
                        title: this.menus[a][b].title,
                        origin_quantity: 1,
                        original_especial_price: this.menus[a][b].price,
                        quantity: 1,
                        remarks: "OkageGo",
                        sub: [],
                    });
                    break;
                }
            }
        }
    }
    localStorage.setItem("orderList", JSON.stringify(this.orderList));

    let currentSelected = await this.storage.get("foods.selected");
    if (!currentSelected) currentSelected = [];
    if (!currentSelected[this.currentItem.aIndex]){
      // aIndexなかったら初期化
      currentSelected[this.currentItem.aIndex] = [];
    }
    if (!currentSelected[this.currentItem.aIndex][this.currentItem.iIndex]){
      // iIndexなかったら初期化
      currentSelected[this.currentItem.aIndex][this.currentItem.iIndex] = 0;
    }
    // 今回の分を加算
    currentSelected[this.currentItem.aIndex][this.currentItem.iIndex] += parseInt(this.quantity, 0);
    // 保存
    await this.storage.set("foods.selected", currentSelected);

    // subs
    var subSelected = JSON.parse(this._okageStorage.getItem('foods.submenu'));
    if (this.currentItem.flowQtt && this.currentItem.flowQtt.length > 0) {
      // update submenu quantity
      for (var i = 0; i < this.currentItem.flowQtt[this.currentItem.id].length; i++) {
        this.subMenu[this.currentItem.id][i].quantity = this.currentItem.flowQtt[this.currentItem.id][i];
      }
      for (let j = 0; j < this.subMenu[this.menu_id].length; j++) {
        if (parseInt(this.subMenu[this.menu_id][j].parent, 0) != this.menu_id) continue;
        subSelected[this.menu_id][j].quantity += this.subMenu[this.menu_id][j].quantity * this.quantity;;
      }
    }
    // 保存
    this._okageStorage.setItem('foods.submenu', JSON.stringify(subSelected));

    // broad cast!
    this.broadcaster.broadcast('foodCounterChanged', 1);
    this.broadcaster.broadcast('submenuChanged', 1);

    var total = 0; // 確認ダイアログで表示する数量を保持

    for (let i = 0; i < this.orderList.length; i++) {
      if (this.orderList[i].menu_id !== this.chargeId) {
        total += Number(this.orderList[i].quantity);
      }
    }

    // 確認を開く
    this.showConfirmDialog(total);
  }

  /**
   * オーダー確認ダイアログをmodalで開く
   */
  showConfirmDialog(total){
    let modal = this.modalCtrl.create(OrderModalPage, { total }, { showBackdrop: false, enableBackdropDismiss: false, enterAnimation: "modal-md-slide-in", leaveAnimation: "modal-md-slide-out" });
    modal.onDidDismiss(data => {
      if (data === 1) {

        // this.navCtrl.parent.select(Config.tab_menu_number.sendorderpage);
        this.goCart.emit({});
      }
      else if (data === 2) {
        this.hideOrder.emit({});
      }
    });
    modal.present();
  }

  /**
   * オーダーを閉じる (@Output)
   * @param a
   * @param b
   */
  hideDetailPopup(a, b){
    this.hideOrder.emit({});
  }


  /**
   * aIndexとiIndexを取得する
   * @param menu_id
   */
  private getIndexes(menu_id){
    for (let a in this.menus){
      for (let i in this.menus[a]){
        let f = this.menus[a][i];
        if (f.id == menu_id){
          return {
            aIndex: parseInt(a, 0),
            iIndex: parseInt(i, 0),
            menu: f
          }
        }
      }
    }
    return {
      aIndex: -1,
      iIndex: -1,
      menu: undefined
    }
  }


  /**
   * 金額フォーマッター
   * @param price
   */
  priceString(price) {
    var newPrice;
    newPrice = String(price).split('.');
    newPrice[0] = newPrice[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    return newPrice.join('.');
  }

  /**
   * アレルギー名フォーマッター
   * @param currentItem
   */
  mergeAllergyText(currentItem) {
    var allergyText = "";
    currentItem.allergy.forEach(allergy => {
        allergyText += allergy.allergy_name+" / ";
    });
    allergyText = allergyText.slice(0, -2)
    return allergyText;
  }

}



// WEBPACK FOOTER //
// ./src/components/order/order.ts